export const config = {
  //   Your Github UserName
  githubUserName: "chan4lk",

  //   Your Github Repo Name Where You Have your issues as Blog
  githubRepo: "blog",

  // Your Personal Blog Title
  title: "Chandima's Blog",

  // Your Personal Blog Subtitle
  subtitle: "Full Stack Developer Blog"
};
